// covered-by: frontends/carrie/src/ask-v2/project/__tests__/AskV2OpenItems.test.tsx
import { type AskPunttMessage } from "@mg/schemas/src/christo/askPuntt";
import { type AskPunttOpenItem } from "@mg/schemas/src/christo/askPunttOpenItems";

export type OpenItemThreadQuestion = {
  question: string;
  header: string;
  options: {
    label: string;
    description?: string;
    value?: string;
  }[];
};

type QuestionCarrier = {
  components?: AskPunttMessage["components"];
};

/**
 * Question forms already drawn on the thread. Later messages win when the
 * same wording was asked twice, so the pane buttons match the form still on
 * screen.
 */
export function openItemThreadQuestions(
  messages: readonly QuestionCarrier[],
): OpenItemThreadQuestion[] {
  const questions: OpenItemThreadQuestion[] = [];
  for (const message of messages) {
    for (const component of message.components ?? []) {
      if (component.componentId !== "ask-puntt.chat-atom.question-form") {
        continue;
      }
      for (const row of component.payload.questions) {
        const question = row.question.trim();
        if (question.length === 0) continue;
        const options = row.options.flatMap((option) => {
          const label = option.label.trim();
          if (label.length === 0) return [];
          return [
            {
              label: option.label,
              ...(option.description != null
                ? { description: option.description }
                : {}),
              ...(option.value ? { value: option.value } : {}),
            },
          ];
        });
        if (options.length === 0) continue;
        questions.push({ question, header: row.header, options });
      }
    }
  }
  return questions;
}

export function threadQuestionForOpenItem(
  item: AskPunttOpenItem,
  questions: readonly OpenItemThreadQuestion[],
): OpenItemThreadQuestion | null {
  const needed = item.needed.trim();
  if (needed.length === 0) return null;
  let match: OpenItemThreadQuestion | null = null;
  for (const question of questions) {
    if (question.question === needed) match = question;
  }
  return match;
}
